module.exports = __webpack_public_path__ + "static/ls2-51d7e9991d84f98be1f287642779ddd6.png";